import { seoForPath } from '../seo'

/**
 * The route's schema.org graph.
 *
 * Rendered in the body rather than the head so the prerenderer captures it with the
 * rest of the markup: it only rewrites the head from headTagSpecs, and a script tag
 * added there by an effect would never reach the static file a crawler reads.
 */
export default function JsonLd({ pathname }: { pathname: string }) {
  const graph = seoForPath(pathname).jsonLd
  if (!graph?.length) return null

  const payload = {
    '@context': 'https://schema.org',
    '@graph': graph,
  }

  return (
    <script
      type="application/ld+json"
      // JSON.stringify escapes nothing that matters inside a script element except a
      // literal "</script>", which cannot occur: every string here is our own copy.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(payload) }}
    />
  )
}
